import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Icon } from 'next/components/ui';

import { TableData, TableHead } from 'components/Common/UI/Table/Styled';

const TableHeader = ({
  children,
  width,
  accessor,
  sortedColumn,
  sortDirection,
  onClick,
}) => (
  <TableHead minWidth={width}>
    <TableData
      onClick={onClick && (() => onClick(accessor))}
      isSortedDesc={sortDirection === 'desc'}
      className={classnames({
        headerCell: true,
        isSorted: accessor === sortedColumn,
        canSort: !!onClick,
      })}
    >
      {children}
      {accessor === sortedColumn && (
        <Icon icon={sortDirection === 'desc' ? `chevron-down` : `chevron-up`} />
      )}
    </TableData>
  </TableHead>
);

TableHeader.propTypes = {
  children: PropTypes.node,
  width: PropTypes.number,
  accessor: PropTypes.string,
  sortedColumn: PropTypes.string,
  sortDirection: PropTypes.string,
  onClick: PropTypes.func,
};

export default TableHeader;
